import { normalizeUser } from "components/coordinator/normalize";
import { getUserFields } from "components/user/config";
import {
  getItemFromCollection,
  getItemsFromCollection,
} from "directus/src/operations";

const COORDINATOR_FIELDS = [
  "id",
  "coordinator.id",
  "coordinator.first_name",
  "coordinator.last_name",
  "coordinator.email",
  "coordinator.title",
  "coordinator.title",
  "coordinator.department.name",
  "coordinator.avatar",
  "coordinator.user.role.name",
  "coordinator.grade.name"
];

export const coordinatorFetchers = {
  PROJECT_WITH_SLUG: async ({ id, role }) => {
    const query = {
      fields: [
        ...COORDINATOR_FIELDS,
        "sales_coordinator.id",
        "sales_coordinator.first_name",
        "sales_coordinator.last_name",
        "sales_coordinator.email",
        "sales_coordinator.title",
        "sales_coordinator.department.name",
        "sales_coordinator.user.role.name",
        "sales_coordinator.avatar",
        "sales_coordinator.grade.name",
        "account_manager.id",
        "account_manager.first_name",
        "account_manager.last_name",
        "account_manager.email",
        "account_manager.title",
        "account_manager.department.name",
        "account_manager.user.role.name",
        "account_manager.avatar",
        "account_manager.grade.name",
      ],
      filter: {
        id: {
          _eq: id,
        },
      },
    };

    // Use key mapping from role to field (for flexibility)
    const roleToField = {
      "Project Coordinator": "coordinator",
      "Account Manager": "account_manager",
      "Sales Coordinator": "sales_coordinator",
    };
    const response = await getItemsFromCollection("projects", query);

    const data = response?.[0]?.[roleToField[role]];

    return data;
  },

  ID: async ({ id, collection, role }) => {
    const query = {
      fields: COORDINATOR_FIELDS,
    };

    const response = await getItemFromCollection(collection, id, query);

    const data = response.coordinator;

    return data;
  },

  ATTRIBUTED_TO: async ({ id, collection }) => {
    const query = {
      fields: [
        "attributed_to.id",
        "attributed_to.first_name",
        "attributed_to.last_name",
        "attributed_to.email",
        "attributed_to.title",
        "attributed_to.department.name",
        "attributed_to.user.role.name",
        "attributed_to.avatar",
        "attributed_to.grade.name"
      ],
    };

    console.log("query", query);

    const response = await getItemFromCollection(collection, id, query);

    const data = response?.attributed_to;

    return data;
  },
};
